import RefData from 'ref-data';

import { NGXAjax } from '../../common/Services/AjaxService';
import { ApiUtils } from '../../common/api';
import { getFormatTypeByCapability } from '../../common/Utils';
import ThemeCollection from './theme-collection';
import ThemeModel from './theme-model';

//TODO themes are to be scoped by the formatType for the given experience so will need to parameterize this once available
function fetchThemes(formatType, containerRef, params) {
  return NGXAjax.get('/api/xp/theme/list.json', {
    validForFormatType:        formatType,
    containerOrLibrary_filter: containerRef,

    //on the console side we ONLY want to work with active themes
    //there might be exceptions, but we can overwrite the API request via
    //a saga call if we need to
    status: RefData.Enum.STATUS.THEME.ACTIVE, //can be overwritten from params

    ...params,
  })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extractWithMeta(['count', 'page']))
    .then(({ content, meta }) => ({
      themes: ThemeCollection.deserialize(content),
      ...meta, //custom pattern to delegate pagination
    }))
    .catch((error) => ({ error }));
}

function fetchTheme(id) {
  return NGXAjax.get('/api/xp/theme/show.json', {
    id,
  })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(ThemeModel.deserialize)
    .catch((error) => ({ error }));
}

function fetchFoundationThemes() {
  return NGXAjax.get('/api/themetemplate/list.json', { validForFormatType: getFormatTypeByCapability() })
    .then(ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(ThemeCollection.deserialize)
    .catch((error) => error);
}

function saveNewTheme(theme) {
  return NGXAjax.post('/api/theme/save.json', theme)
    .then(ApiUtils.validate)
    .then(ApiUtils.extract1)
    .catch((error) => error);
}

export default {
  fetchThemes,
  fetchTheme,
  fetchFoundationThemes,
  saveNewTheme,
};
